export default "__VITE_ASSET__DTLV84UJ__"